export const API_URL =
  "https://65803cdd6ae0629a3f54b7fb.mockapi.io/api/videos/mp4";
